import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Col,
  Row,
  FormGroup,
  Label,
  Input,
  Button,
  Table,
  ModalFooter,
} from "reactstrap";
import { useDispatch } from "react-redux";
import { urlAPI, getUser, getToken } from "utility/Common";
import Axios from "axios";
import moment from "moment";
import Select from "react-select";
import Center from "react-center";

const initDataState = {
  KODE_INVENTARIS: "",
  KODE_BARANG: "",
  NAMA_BARANG: "",
  MERK: "",
  KONDISI: "",
};

export default function InventarisFormEditMutasi(props) {
  const { onSaved, onClosed, open, data } = props;
  const dispatch = useDispatch();
  const [dataState, setDataState] = useState(initDataState);
  const [loading, setLoading] = useState(false);
  const [loadingLoad, setLoadingLoad] = useState(false);
  const [ID, setID] = useState(null);

  const [hidden, setHidden] = useState(false);

  const [selectorUnit, setSelectorUnit] = useState([]);
  const [loadingUnit, setLoadingUnit] = useState(false);

  useEffect(() => {
    if (open) {
      if (data !== null) {
        console.log("data edit", data);
        // setLoadingLoad(true);
        setID(data?.id);
        setDataState(data);

        setLoadingUnit(true);
        fetchSelectorUnit();
      }
    }
  }, [open]);

  const handleSimpan = () => {
    console.log("simpan", dataState);

    Axios.put(urlAPI + "/v1/Inventaris/inventarismut", {
      DATA: dataState,
      ID: data?.id,
    })
      .then((response) => {
        dispatch({
          type: "FILL_BERHASIL",
          berhasil: true,
          pesan: response.data.message,
        });
        setLoading(false);
        setDataState(initDataState);
        setID(null);
        onSaved();
      })
      .catch((err) => {
        if (err.response?.statusText === "Unauthorized") {
          setLoading(false);
          // dispatch(handleActionLogout());
        } else {
          dispatch({
            type: "FILL_GAGAL",
            gagal: true,
            pesan: err?.response?.data?.message,
          });
          setLoading(false);
        }
      });
  };

  const fetchSelectorUnit = () => {
    Axios.get(
      urlAPI +
        "/v1/unitlayanan/bysbu?params=" +
        JSON.stringify({
          isSelector: true,
          sbu: getUser()?.sbu,
        }),
      {
        headers: {
          Authorization: "Bearer " + getToken(),
        },
      }
    )
      .then((response) => {
        if (response?.data?.result?.rows?.length !== 0) {
          const selectorTemp = response?.data?.result?.rows?.map((obj) => ({
            value: obj?.kodeunit,
            label:
              obj?.kodeunit === ""
                ? obj?.kodeunit
                : obj?.kodeunit + " | " + obj?.namaunit,
            name: obj?.namaunit,
            jenis2: obj?.jenis2,
          }));
          setSelectorUnit(selectorTemp);
          setLoadingUnit(false);
        } else {
          setLoadingUnit(false);
        }
      })
      .catch((err) => {
        if (err.response?.statusText === "Unauthorized") {
          setLoadingUnit(false);
          // dispatch(handleActionLogout());
        } else {
          dispatch({
            type: "FILL_GAGAL",
            gagal: true,
            pesan: err?.response?.data?.message,
          });
          setLoadingUnit(false);
        }
      });
  };

  // console.log("data", data);
  console.log("data state", dataState);
  return (
    <>
      <Modal
        isOpen={open}
        toggle={onClosed}
        className="modal-dialog-centered modal-lg"
        backdrop="static"
        hidden={hidden}
      >
        <ModalHeader toggle={onClosed}>MUTASI DATA INVENTARIS</ModalHeader>
        <ModalBody>
          {loadingLoad ? (
            <h4>Loading...</h4>
          ) : (
            <>
              <Row>
                <Col lg="6" md="6" sm="12">
                  <Label for="nama">KODE INVENTARIS</Label>
                  <Input
                    type="text"
                    id="kode_inventaris"
                    value={dataState.KODE_INVENTARIS}
                    onChange={(e) => {
                      setDataState({
                        ...dataState,
                        KODE_INVENTARIS: e.target.value.toUpperCase(),
                      });
                    }}
                  />
                </Col>
                <Col lg="6" md="6" sm="12">
                  <Label for="nama">NAMA BARANG</Label>
                  <Input
                    type="text"
                    id="nama_barang"
                    value={dataState.NAMA_BARANG}
                    onChange={(e) => {
                      setDataState({
                        ...dataState,
                        NAMA_BARANG: e.target.value.toUpperCase(),
                      });
                    }}
                  />
                </Col>
                <Col lg="6" md="6" sm="12">
                  <Label for="nama">KODE BARANG</Label>
                  <Input
                    type="text"
                    id="kode_barang"
                    value={dataState.KODE_BARANG}
                    onChange={(e) => {
                      setDataState({
                        ...dataState,
                        KODE_BARANG: e.target.value.toUpperCase(),
                      });
                    }}
                  />
                </Col>
                <Col lg="6" md="6" sm="12">
                  <Label for="nama">MERK BARANG</Label>
                  <Input
                    type="text"
                    id="merk_barang"
                    value={dataState.MERK}
                    onChange={(e) => {
                      setDataState({
                        ...dataState,
                        MERK: e.target.value.toUpperCase(),
                      });
                    }}
                  />
                </Col>
                <Col lg="6" md="6" sm="12">
                  <Label for="nama">QTY</Label>
                  <Input
                    type="text"
                    id="qty"
                    value={dataState.QTY}
                    onChange={(e) => {
                      setDataState({
                        ...dataState,
                        QTY: e.target.value.toUpperCase(),
                      });
                    }}
                  />
                </Col>
                <Col lg="6" md="6" sm="12">
                  <Label for="nama">KONDISI</Label>
                  <Input
                    name="KONDISI"
                    type="text"
                    id="kondisi"
                    value={dataState.KONDISI}
                    onChange={(e) => {
                      setDataState({
                        ...dataState,
                        KONDISI: e.target.value.toUpperCase(),
                      });
                    }}
                  />
                </Col>
                <Col lg="6" md="6" sm="12">
                  <Label for="nama">KETERANGAN</Label>
                  <Input
                    type="text"
                    id="keterangan"
                    value={dataState.KET}
                    onChange={(e) => {
                      setDataState({
                        ...dataState,
                        KET: e.target.value.toUpperCase(),
                      });
                    }}
                  />
                </Col>

                <Col lg="6" md="6" sm="12">
                  <FormGroup>
                    <Label>PINDAH KE UNIT ?</Label>
                    <Select
                      styles={{
                        color: "black",
                      }}
                      id="unit"
                      name="unit"
                      isLoading={loadingUnit}
                      options={selectorUnit}
                      value={selectorUnit.find(
                        (find) => find.value === dataState?.POLI
                      )}
                      onChange={(e) => {
                        setDataState({
                          ...dataState,
                          POLI: e?.value ? e.value : null,
                        });
                      }}
                    />
                  </FormGroup>
                </Col>
              </Row>
            </>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            color="success"
            onClick={() => {
              setLoading(true);
              handleSimpan();
            }}
            disabled={loading}
          >
            Simpan
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}
